"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalContextStorageProvider = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const CONTEXT_SYMBOL = Symbol.for('aws.lambda.runtime.context');
;
exports.GlobalContextStorageProvider = {
    getContext: () => global[CONTEXT_SYMBOL],
    setContext: (map) => (global[CONTEXT_SYMBOL] = map),
};
